import React from "react";
import BlocAccueil from "../components/BlocAccueil";

function SectionAccueil(){
    return(
        <section id="sectionAccueil" style={{ height: "100vh"}}>
            <BlocAccueil />
        </section>
    );
}

export default SectionAccueil